/*
 * @Author: mayanxia 
 * @Date: 2023-03-08 19:22:37 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-03-08 19:33:16
 */


<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
       <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.title">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <detail-list :col="2" size="small">
                <detail-list-item :term="$t('终端号')">{{model.terminalNo}}</detail-list-item>
                <detail-list-item :term="$t('状态')">{{model.meterSwitchStatus == 0?$t('关泵'):model.meterSwitchStatus == 1?$t('在线抽水中'):'--'}}</detail-list-item>
                <detail-list-item :term="$t('计量方式(m³/h)')">{{model.measureWay}}</detail-list-item>
                <detail-list-item :term="$t('上传时间')">{{model.sysTime}}</detail-list-item>
                <detail-list-item :term="$t('取水井名')">{{model.deviceName}}</detail-list-item>
                <detail-list-item :term="$t('井地址')">{{model.deviceLocation}}</detail-list-item>
                <detail-list-item :term="$t('水利编号')">{{model.waterConservancyNo}}</detail-list-item>
                <detail-list-item :term="$t('取水证号及电子证号')">{{model.waterCollectionNo}}</detail-list-item>
                
                
                <detail-list-item :term="$t('总用水量(m³)')">{{model.meterTotalUse}}</detail-list-item>
                <detail-list-item :term="$t('剩余水量(m³)')">{{model.meterRemainNum}}</detail-list-item>
                <detail-list-item :term="$t('报警状态')">{{model.meterWarnStatus == 1?$t('综合保护器报警'):model.meterWarnStatus == 2?$t('有脉冲干扰'):model.meterWarnStatus == 3?$t('断线报警'):$t('正常')}}</detail-list-item>
                <detail-list-item :term="$t('箱门状态')">{{model.meterDoorStatus == 0?$t('箱门关闭'):model.meterDoorStatus == 1?$t('箱门开启'):'--'}}</detail-list-item>
              </detail-list>
            </div>
            <a-table
              v-else-if="activeKey != 1"
              ref="table"
              size="middle"
              :scroll="{y:'calc(70vh - 300px)',x:true}"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'EmfFlowUpDataLastRecordModal',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        bodyStyle: {
          height: '60vh',
          'overflow-y': 'hidden'
        },
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/wq/partWellElecControllLastRecord/add",
          edit: "/jeecg-charge/wq/partWellElecControllLastRecord/edit",
          queryById: "/jeecg-charge/wq/partWellElecControllLastRecord/queryById",
          list: "/jeecg-charge/wq/partWellElecControllLastRecord/list"
        },
        meterSignal: {},
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      tabList() {
        return [
          {key: 1,title: this.$t('基本信息')},
          //{key: 2,title: '历史数据'}
        ]
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },/*{
            title:'设备名称',
            align:"center",
            dataIndex: 'deviceName'
          },{
            title:'安装位置',
            align:"center",
            dataIndex: 'deviceLocation'
          },*/
          {
            title: this.$t('压力值(MPa)'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值(℃)'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('总累计流量(m³)'),
            align:"center",
            dataIndex: 'throughputTotal'
          },
          {
            title: this.$t('正向流量(m³)'),
            align:"center",
            dataIndex: 'throughput'
          },
          {
            title: this.$t('反向流量(m³)'),
            align:"center",
            dataIndex: 'throughputMinus'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime'
          }
        ]
      },
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }
        
      }
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        
        this.model = Object.assign({}, record);
        this.uniqueParam.deviceId = this.model.meterId
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>